<template>
  <div class="page-info">
    <div class="page-info-icon">
      <f-sprite-icon :icon-link="icon" />
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <h2 v-if="title" class="title" v-html="sanitize(title)" />
    <p v-if="subtitle" class="description" v-html="sanitize(subtitle)" />
    <!-- eslint-enable vue/no-v-html -->
    <p v-if="$slots.default" class="description">
      <slot />
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { sanitize } from '@/utils/sanitize';

import IconInfo from '../../assets/images/info.multi.svg';

export default defineComponent({
  name: 'page-info',

  props: {
    icon: {
      type: String,
      default: () => IconInfo,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      sanitize,
    };
  },
});
</script>

<style lang="scss">
.page-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px auto;

  .page-info-icon {
    & > svg {
      width: 64px;
      height: 64px;
    }
  }

  .title,
  .description {
    color: $black;
    text-align: center;
  }

  .title {
    margin: 16px 0 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    font-family: Gilroy, sans-serif;
  }

  .description {
    max-width: 436px;
    padding: 4px 8px 8px;
    font-size: 14px;
    line-height: 20px;

    a {
      color: $blue;
    }
  }
}

@include breakpoint("tablet") {
  .page-info {
    .title {
      font-size: 20px;
      line-height: 28px;
    }

    .description {
      padding: 8px;
      font-size: 16px;
      line-height: 24px;
    }
  }
}

@include breakpoint("desktop") {
  .page-info {
    margin: 120px auto;
  }
}
</style>
